export default {"src":"/_next/static/media/apk-qr-primexbt-markets-pro.8adc2c1d.svg","height":245,"width":245,"blurWidth":0,"blurHeight":0};